import React, { useState } from "react";
import { Box, Tabs, Tab, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import ReimbursementPageV1 from "./Reimbursement";
import ReimbursementV2Page from "./ReimbursementV2Page";

/**
 * Combined Reimbursement Page with tabs for V1 and V2
 * - V1 tab: Read-only historical reimbursement requests
 * - V2 tab: New reimbursement request submission and management
 */
const ReimbursementPage: React.FC = () => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState(0);

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
  };

  return (
    <Box>
      <Box sx={{ mb: 3 }}>
        <Typography variant="h4" sx={{ mb: 2 }}>
          {t("reimbursement.title")}
        </Typography>
        <Tabs
          value={activeTab}
          onChange={handleTabChange}
          aria-label="reimbursement tabs"
          sx={{
            borderBottom: 1,
            borderColor: "divider",
          }}
        >
          <Tab
            label={t("reimbursement.v2.tab")}
            id="tab-v2"
            aria-controls="tabpanel-v2"
          />
          <Tab
            label={t("reimbursement.v1.tab")}
            id="tab-v1"
            aria-controls="tabpanel-v1"
          />
        </Tabs>
      </Box>

      {/* V2 Tab Panel */}
      <Box
        role="tabpanel"
        hidden={activeTab !== 0}
        id="tabpanel-v2"
        aria-labelledby="tab-v2"
      >
        {activeTab === 0 && <ReimbursementV2Page />}
      </Box>
      {/* V1 Tab Panel */}
      <Box
        role="tabpanel"
        hidden={activeTab !== 1}
        id="tabpanel-v1"
        aria-labelledby="tab-v1"
      >
        {activeTab === 1 && <ReimbursementPageV1 />}
      </Box>
    </Box>
  );
};

export default ReimbursementPage;
